import {Box, Button} from '@chakra-ui/react';

export default function Header() {
  return (
      <Box margin={2}>
        <Button>Bin2Dec</Button>
      </Box>
  );
}